import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../context/auth-context'

/**
 * Exchanges the OAuth authorization code once.
 * ASSUMPTION: React StrictMode remounts effects in dev; without a guard the
 * same one-time code is posted twice → auth server returns invalid_grant.
 */
const consumedCodes = new Set<string>()

export default function OAuthCallback() {
  const location = useLocation()
  const auth = useAuth()
  const startedRef = useRef(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const code = searchParams.get('code')
    if (!code || startedRef.current || consumedCodes.has(code)) {
      return
    }

    startedRef.current = true
    consumedCodes.add(code)
    void auth.handleOAuthCallback(code)
  }, [location, auth])

  return <div>Loading...</div>
}
